"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCDNUtils = exports.toCDNImageModifierString = void 0;
const s3_url_parser_1 = __importDefault(require("s3-url-parser"));
const const_1 = require("./const");
/**
 * Transform modifiers object to string format .eg `width_{width},quality_{quality}`
 */
function toCDNImageModifierString(modifiers) {
    if (!modifiers)
        return const_1.NOOP_MODIFIER;
    const modStr = Object.entries(modifiers).reduce((acc, [k, v]) => {
        const value = numberSafeParse(v);
        if (value) {
            if (acc.length > 0) {
                acc += ",";
            }
            acc += `${k}_${value}`;
        }
        return acc;
    }, "");
    return modStr ? modStr : const_1.NOOP_MODIFIER;
}
exports.toCDNImageModifierString = toCDNImageModifierString;
function transformImageUrl(cdnBaseUrl, imageUrl, modifiers) {
    try {
        const cdnUrl = new URL(cdnBaseUrl);
        const imgUrl = new URL(imageUrl);
        // image's url is already based on CDN url, apply modifiers only.
        if (imgUrl.hostname === cdnUrl.hostname) {
            const [_mod, ...tokens] = imgUrl.pathname
                .split("/")
                .filter((s) => Boolean(s));
            const newMod = toCDNImageModifierString(modifiers);
            imgUrl.pathname = [newMod, ...tokens].join("/");
            return imgUrl.toString();
        }
        // remove query/hash
        imgUrl.search = "";
        imgUrl.hash = "";
        // parse
        const parsed = (0, s3_url_parser_1.default)(imgUrl.toString());
        if (!parsed || !parsed.bucket || !parsed.key) {
            throw new Error(`Invalid S3 url: ${imageUrl}`);
        }
        // construct CDN url
        cdnUrl.pathname = [
            toCDNImageModifierString(modifiers),
            parsed.bucket,
            parsed.key,
        ].join("/");
        return cdnUrl.toString();
    }
    catch (err) {
        if (err instanceof Error) {
            if (process.env.NODE_ENV === "development") {
                console.warn("@setel/cdn-sdk:", err.message);
            }
        }
        // if error just return the original url
        return imageUrl;
    }
}
/**
 * Factory function to create CDN utilities
 */
function createCDNUtils(cdnBaseUrl) {
    const _toCDNImageUrl = (imageUrl, modifiers) => {
        return transformImageUrl(cdnBaseUrl, imageUrl, modifiers);
    };
    return { toCDNImageUrl: _toCDNImageUrl };
}
exports.createCDNUtils = createCDNUtils;
// Return `null` instead of `NaN` on failure (with matching type)
// Doesn't parse things like "42foo" as `42` (vs using `Number. parseFloat()`)
// Doesn't parse whitespace-only strings as `0` (vs using `Number()`)
// Doesn't parse "NaN" into `NaN` or "Infinity" into `Infinity` (VS `Number()` or `Number parseFloat()`)
// In short, only parses token sequences that are *exactly* valid JS numbers
function numberSafeParse(input) {
    if (typeof input === "string" && input.trim() === "")
        return null;
    let parsed = Number(input);
    if (!Number.isFinite(parsed))
        return null;
    return parsed;
}
//# sourceMappingURL=sdk.js.map